<template>
  <div class="tableFilterBox">
    <GlobalForm
      :init-data="formData"
      :form-item-list="formItemList"
      round
      size="mini"
      :inline="true"
      @handleChange="handleChange"
      @handleConfirm="confirmSearch"
      confirm-btn-name="搜索"
    >
      <el-radio-group
        slot="radioBtns"
        v-model="fixedTimeItem"
        @change="formData.date = ''"
      >
        <el-radio-button label="1">昨天</el-radio-button>
        <el-radio-button label="2">近7天</el-radio-button>
        <el-radio-button label="3">近30天</el-radio-button>
      </el-radio-group>
    </GlobalForm>

    <div class="exportBtn">
      <el-button size="small" plain @click="exportData">
        <img
          class="uploadIcon"
          src="@/assets/images/xinyulou/icon_upload.png"
        />
        导出数据
      </el-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import _api from "@/utils/request";
import { _http } from "@/utils/request/storeStatistics";
let postionTime = Date.now();
export default {
  data() {
    return {
      // 筛选部分
      formData: {
        companyId: "", // 项目部
        areaId: "", // 门店
        storeId: "", // 柜组
        tagId: "", // 柜组标签
        date: "", // 筛选日期
      },
      formItemList: [
        {
          type: "selectFilterable",
          labelName: "项目部",
          placeholder: "请输入项目部名称",
          key: "companyId",
          clear: true,
          clearFun() {},
          lableWidth: "56px",
          option: [],
        },
        {
          type: "selectFilterable",
          labelName: "门店",
          placeholder: "请输入门店名称",
          key: "areaId",
          clear: true,
          disabled: true,
          clearFun() {},
          lableWidth: "50px",
          option: [],
        },
        {
          type: "selectFilterable",
          labelName: "柜组",
          placeholder: "请输入柜组名称",
          key: "storeId",
          clear: true,
          disabled: true,
          clearFun() {},
          lableWidth: "50px",
          option: [],
        },
        {
          type: "selectFilterable",
          labelName: "柜组标签",
          placeholder: "请输入柜组标签",
          key: "tagId",
          clear: true,
          // disabled: true,
          clearFun() {},
          lableWidth: "84px",
          option: [],
        },
        {
          slotName: "radioBtns",
        },
        {
          type: "pickerOptions",
          clearable: true,
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && !maxDate) {
                this.startDate = minDate;
              } else {
                this.startDate = null;
              }
            },
            disabledDate: (time) => {
              // 获取今天 0 点时间戳（关键修复 1）
              // const today = new Date();
              // today.setHours(0, 0, 0, 0);
              // const todayStamp = today.getTime();

              // // 1. 禁止选择【今天以后】的日期 → 今天可以选
              // if (time.getTime() - 1000 * 60 * 60 * 24 > todayStamp) {
              //   return true;
              // }

              // 2. 已选开始日期 → 只能选 开始日期 ±30天（关键修复 2）
              if (this.startDate) {
                const start = new Date(this.startDate);
                start.setHours(0, 0, 0, 0);

                // 正确计算：以选中的开始日期为基准
                const maxAllowDate = new Date(start);
                maxAllowDate.setDate(start.getDate() + 30);

                const minAllowDate = new Date(start);
                minAllowDate.setDate(start.getDate() - 30);

                // 不在 [min, max] 区间内就禁用
                return time < minAllowDate || time > maxAllowDate;
              }

              return false;
            },
          },
          key: "date",
        },
      ],
      fixedTimeItem: "2", // 固定时间【默认展示上近7天数据】

      // 项目部列表
      group_list: [],
      group_id: "",
    };
  },
  watch: {
    "formData.date": {
      handler(val) {
        if (val && val.length > 0) {
          this.fixedTimeItem = "";
        } else if (!this.fixedTimeItem) {
          this.fixedTimeItem = "2";
        }
      },
    },
  },
  created() {
    this.confirmSearch();
  },
  mounted() {
    this.getcompanyIdList();
    this.getStoreTagList();
  },
  methods: {
    getTableData() {},
    // 下拉框更新
    handleChange(item, value) {
      this.formData[item.key] = value; // 赋值

      this._dataSet(item.key, value);
    },

    // 为了实现多级联动提取出来的公共数据重置逻辑
    _dataSet(key, value) {
      // 数据的字段名+请求列表的函数名
      const keyArr = [
        { key: "companyId" },
        { key: "areaId", apiName: "getAreaSelect" },
        { key: "storeId", apiName: "getStoreSelectList" },
        // { key: "tagId", apiName: "getStoreTagSelect" },
      ];
      const nextKeyIndex = keyArr.findIndex((r) => r.key === key) + 1;

      // 当未获取到或者已经到最后一级时，不需要再进行后续操作
      if (nextKeyIndex <= 0 || nextKeyIndex >= keyArr.length) {
        return;
      }

      for (let i = nextKeyIndex; i < keyArr.length; i++) {
        const key = keyArr[i].key;
        this.formData[key] = ""; // 后级需要置空，重新选择

        if (!value) {
          this.formItemList[i].option = [];
          this.formItemList[i].disabled = true;
        }
      }

      if (value) {
        const params = {
          [key]: value,
        };

        // 开始请求接口
        this.formItemList[nextKeyIndex].disabled = false; // b变为非禁用
        _http[keyArr[nextKeyIndex].apiName](params).then((res) => {
          if (res.code === 1) {
            this.formItemList[nextKeyIndex].option = res.data.map((r) => ({
              value: r.areaId || r.key || r.id,
              label: r.areaName || r.value || r.name,
            }));
          }
        });
      }
    },
    // 获取项目部列表（平台后台的门店商家）
    getcompanyIdList() {
      // console.log("moment().day():", moment().day() - 6);
      _http.getSelectList().then((res) => {
        if (res.code === 1) {
          this.formItemList[0].option = res.data.map((r) => ({
            value: r.id,
            label: r.name,
          }));
        }
      });
    },
    // // 获取门店列表（门店系统的区域）
    // getStoreList() {
    //   _http
    //     .getAreaSelect({
    //       companyId: this.formData.companyId,
    //     })
    //     .then((res) => {
    //       if (res.code === 1) {
    //         this.formItemList[1].option = res.data.map((r) => ({
    //           value: r.areaId,
    //           label: r.areaName,
    //         }));
    //       }
    //     });
    // },
    // // 获取柜组列表（门店系统的门店）
    // getGroupList() {
    //   _http.getStoreSelectList({ areaId: this.formData.areaId }).then((res) => {
    //     // console.log(res);
    //     if (res.code === 1) {
    //       // this.storeList = res.data;
    //       this.formItemList[2].option = res.data.map((r) => ({
    //         value: r.key,
    //         label: r.value,
    //       }));
    //     }
    //   });
    // },
    // 获取柜组标签列表
    getStoreTagList() {
      _http.getStoreTagSelect().then((res) => {
        if (res.code === 1) {
          this.formItemList[3].option = res.data.map((r) => ({
            value: r.id,
            label: r.name,
          }));
        }
      });
    },

    _getFilterData() {
      const filterData = { ...this.formData };
      delete filterData.date;

      switch (this.fixedTimeItem) {
        case "1": // 昨天
          filterData.endTime = moment()
            .endOf("day")
            .add(-1, "days")
            .format();
          filterData.startTime = moment()
            .startOf("day")
            .add(-1, "days")
            .format();
          break;
        case "2": // 近七天
          filterData.endTime = moment()
            .endOf("day")
            .format();
          filterData.startTime = moment()
            .startOf("day")
            .add(-7, "days")
            .format();
          break;
        case "3": // 近30天
          filterData.endTime = moment()
            .endOf("day")
            .format();
          filterData.startTime = moment()
            .startOf("day")
            .add(-30, "days")
            .format();
          break;
        default:
          if (this.formData.date) {
            filterData.startTime = moment(this.formData.date[0]).format();
            filterData.endTime = moment(this.formData.date[1]).format();
          }
      }

      return filterData;
    },

    // 确认搜索
    confirmSearch() {
      const filterData = this._getFilterData();
      // console.log("筛选的条件：", filterData);
      this.$emit("dataFilter", filterData);
    },

    // 导出数据
    exportData() {
      const filterData = this._getFilterData();
      const resDt = {
        ...filterData,

        inspectorId: 0,
        pageNum: 0,
        pageSize: 0,
      };

      _http.exportStatisticsExcel(resDt).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "门店数据.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tableFilterBox {
  /deep/ .el-form-group {
    padding: 0 20px;
  }
  .exportBtn {
    padding: 20px;
    border-top: 1px solid #f5f6fa;
    .uploadIcon {
      width: 10px;
      height: 10px;
      margin-right: 5px;
    }
  }
}
</style>
